import { Injectable } from '@angular/core';
import { CrudService } from './crud.service';
import type { Announcement, AnnouncementReadPayload } from '../interfaces/announcement';
import type { Observable } from 'rxjs';
import { environment } from '../../environment/environment';
import type { ApiResponse } from '../interfaces/application';

@Injectable({
  providedIn: 'root',
})
export class AnnouncementsService extends CrudService<Announcement> {
  constructor() {
    super('announcements');
  }

  public read(id: string, payload: AnnouncementReadPayload): Observable<ApiResponse<Announcement>> {
    return this._http.post<ApiResponse<Announcement>>(`${environment.api}/${this.path}/${id}/read`, payload);
  }
}
